export default __webpack_public_path__ + "static/media/BookClub.e1a4087a857fa5790016411ab2e4e732.webp";